<template
  ><div>
    <div id="gosee-nav">
      <span class="gosee-exit" v-on:click="backToHome()"
        >&lt;&nbsp;&nbsp;返回</span
      >
      <img src="@/assets/images/call-title.png" alt="" class="result-title" />
    </div>
    <img
      src="@/assets/images/bgTitle.png"
      style="width: 100%;vertical-align: top;height: 18px;"
    />
    <div id="call">
      <p class="oneCall">
        在桃桃喜公众号本测试的使用过程中，如果遇到问题，您可以在这里得到帮助。
      </p>
      <p class="twoCall">
        客服邮箱：<span>customer_service@haohaoming.com</span>
      </p>
      <p class="threeCall">
        <span style="font-size: 20px">常见问题：</span
        ><br />1.在哪里可以查询订单？<br /><span
          >在测试首页，点击“历史记录”按钮即可查询订单。</span
        ><img
          src="@/assets/images/callImg.png"
          alt=""
        /><br />2.付款成功，未成功获取结果怎么办？<br /><span
          >如果已经付款成功，因为网络等原因没有得到测试结果，我们会将您的测试结果保存在按钮“历史订单”中。只需要点击历史订单，即可找到您的测试结果。</span
        ><img
          src="@/assets/images/callIm2.png"
          alt=""
        /><br />3.知识付费产品可以退款吗？<br /><span
          >本测试为知识付费产品，测算结果均为占卜大师根据专业知识和经验得出。一经购买概不退款。</span
        ><br />4.付款后发现八字信息输错可以退款吗？<br /><span
          >本测试测算结果均为占卜大师根据专业知识和经验得出。一次测试即一次消费，一经购买概不退款。请测试前仔细核对八字信息。</span
        >
      </p>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    backToHome: function() {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>
<style></style>
